import { AlertTriangle } from "lucide-react";

const NO_GUARANTEE = [
  "Visitor visa approval",
  "Study permit approval",
  "Work permit approval",
  "Employment",
  "Internship placement",
  "Permanent residence",
  "Immigration status",
  "Admission to a school or university",
  "Entry into any country",
  "Future immigration benefits",
];

const RESPONSIBILITIES = [
  "Applying for the correct visa or travel authorization",
  "Providing truthful and complete information",
  "Meeting all immigration requirements",
  "Maintaining valid travel documents",
  "Obtaining medical and travel insurance",
  "Following program rules",
  "Leaving the destination country as required",
  "Avoiding unauthorized work or study",
];

export default function Disclaimer() {
  return (
    <div className="max-w-4xl mx-auto px-5 lg:px-8 py-16" data-testid="disclaimer-page">
      <div className="rounded-3xl bg-amber-50 border border-amber-200 p-6 md:p-8 mb-10 flex gap-4">
        <AlertTriangle className="w-6 h-6 text-amber-600 shrink-0" />
        <div>
          <h1 className="font-display text-2xl md:text-3xl font-extrabold text-slate-900">
            Important Program and Immigration Disclaimer
          </h1>
          <p className="mt-2 text-sm text-amber-900">Please read this page carefully before applying.</p>
        </div>
      </div>

      <div className="space-y-6 text-slate-700 leading-relaxed" data-testid="disclaimer-content">
        <p>
          StudyTrip Global provides short-term educational, professional-development, cultural, and international exposure programs.
        </p>
        <p>
          StudyTrip Global is not an immigration law firm, immigration consultancy, visa office, government agency, college, university, employment agency, or recruitment company unless specifically stated otherwise.
        </p>

        <div>
          <h2 className="font-display text-xl font-bold text-slate-900 mb-3">Participation in a program does not guarantee:</h2>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            {NO_GUARANTEE.map((n) => <li key={n}>{n}</li>)}
          </ul>
        </div>

        <p>
          Visa, travel, entry, and immigration decisions are made solely by the relevant government authorities.
        </p>

        <div>
          <h2 className="font-display text-xl font-bold text-slate-900 mb-3">Participants are responsible for:</h2>
          <ul className="list-disc pl-6 space-y-1 text-slate-700">
            {RESPONSIBILITIES.map((n) => <li key={n}>{n}</li>)}
          </ul>
        </div>

        <p>
          Program prices, schedules, accommodation, transportation, visits, activities, instructors, speakers, and locations may change due to availability, weather, safety, regulations, travel restrictions, operational requirements, or circumstances beyond our control.
        </p>
        <p>
          Starting prices are not guaranteed final prices. A formal quotation will be issued before registration.
        </p>
        <p>
          Programs do not include employment, paid work, productive workplace duties, or immigration services unless specifically and legally authorized.
        </p>

        <div id="privacy" className="pt-8 border-t border-slate-100">
          <h2 className="font-display text-xl font-bold text-slate-900 mb-3">Privacy Policy</h2>
          <p>We collect only the information you voluntarily provide through our application, contact, and partner inquiry forms. We use this information solely to process your inquiry and communicate with you about our programs. We do not sell your personal information.</p>
        </div>

        <div id="terms" className="pt-8 border-t border-slate-100">
          <h2 className="font-display text-xl font-bold text-slate-900 mb-3">Terms and Conditions</h2>
          <p>By submitting any form on this website, you confirm that the information provided is accurate and complete. Program participation is subject to a formal quotation, registration agreement, and payment terms, which will be issued separately. All prices are estimates until confirmed in writing.</p>
        </div>
      </div>
    </div>
  );
}
